import { Component, Prop, Method, Event, EventEmitter, h, Host } from '@stencil/core';

@Component({
  tag: "zpr-accordion-panel"
})

export class ZprAccordionPanel {
    @Event() panelOpened: EventEmitter;
    @Prop({mutable:true}) isOpen?: boolean = false;

    @Method()
    async open() {
        if (this.isOpen) return;
        this.isOpen = true;
        this.panelOpened.emit()
    }

    @Method()
    async close() {
        if (!this.isOpen) return;
        this.isOpen = false;
    }

    @Method()
    async toggle() {
        this.isOpen = !this.isOpen;
        if(this.isOpen) this.panelOpened.emit();
    }

    render() {
        return (
            <Host>
            <div class="accordion-content">
                <div class="flex btw acenter accordion-heading" onClick={() => this.toggle()}>
                    <slot name="accordion-header"/>
                    <div><span class={!this.isOpen? 'arrow' : 'arrow arrow-up'}></span></div>
                </div>

                <div class={this.isOpen? "accordion-open" : "accordion-closed"}>
                    <slot name="accordion-body"/>
                </div>
            </div>
            </Host>
        )
    }
}
